
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppButton, AppTable } from '@/components';
import { useIAPList } from '@/modules/iap/model/list';
import { useMixins } from '@/modules/iap/model/mixins';
import { ROUTE_NAME_IAP } from '@/modules/iap/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_IAP.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, fetchList, actions } = useIAPList();
        const { features } = useMixins();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Option, label: 'Payment Feature', key: 'feature', options: features },
                { type: TableColumnType.Text, label: 'Package ID', key: 'packageId' },
                { type: TableColumnType.Text, label: 'Price ID', key: 'priceId' },
                { type: TableColumnType.Text, label: 'Price', key: 'price' },
                { type: TableColumnType.Text, label: 'Credit', key: 'credit' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_IAP.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-copy',
                        theme: 'info',
                        tooltip: 'Clone',
                        to: { name: ROUTE_NAME_IAP.CLONE, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, ROUTE_NAME_IAP };
    }
});
